import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { clearSavedInviteParams, getSavedInviteParams } from '../../utils/urlParams';
import { useJoinTenantByInviteMutation } from '../../api/tenant';
import { openModal } from '../../Store/modalSlice';

type Props = {
  tenantName?: string;
  closeModal?: () => void;
};

const InviteJoinConfirmModal: React.FC<Props> = ({ tenantName, closeModal }) => {
  const [ack, setAck] = useState(false);
  const dispatch = useDispatch();
  const [joinTenantByInvite, { isLoading }] = useJoinTenantByInviteMutation();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">Join Tenant</h3>
      <p>You are joining {tenantName || 'the organization'}.</p>
      <div className="bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-700 text-yellow-800 dark:text-yellow-200 p-3 rounded">
        You will lose access to your previous account and all its data.
      </div>
      <label className="flex items-start gap-2">
        <input type="checkbox" className="mt-1" checked={ack} onChange={(e) => setAck(e.target.checked)} />
        <span>I am sure I want to join and I understand the consequences.</span>
      </label>
      <div className="flex justify-end gap-2 pt-2">
        <button className="btn btn-ghost" onClick={closeModal}>Cancel</button>
        <button 
          className={`btn btn-primary ${(!ack || isLoading) ? 'opacity-50 pointer-events-none' : ''}`}
          onClick={async () => {
            if (!ack) return;
            const hash = getSavedInviteParams().invite_hash;
            if (!hash) return;
            try {
              await joinTenantByInvite({ invitationHash: hash }).unwrap();
              closeModal && closeModal();
            } catch (e) {
              // Closing silently made a failed join look identical to a
              // successful one. InviteErrorModal already handles 'join_failed';
              // it just was never dispatched from anywhere.
              dispatch(openModal({ type: 'invite-error' as any, width: 'md', props: { reason: 'join_failed' } }));
            } finally {
              try { clearSavedInviteParams(); } catch {}
            }
          }}
        >
          {isLoading ? 'Joining...' : 'Join'}
        </button>
      </div>
    </div>
  );
};

export default InviteJoinConfirmModal;


